import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import activeSubServiceId from "./slices/subServiceId";
import ActiveTab from "./slices/activeTabSlice";
import addressSlice, { fetchUserAddress } from "./slices/addressSlice";
import cartSlice, { setCartData } from "./slices/cartSlice";
import categoryProductSlice from "./slices/categoryProductSlice";
import ecomProductSlice from "./slices/ecomProductSlice";
import ecomPackageSlice from "./slices/ecomPackageSlice";
import productSlice, { fetchProduct } from "./slices/productSlice";
import searchKeysSlice from "./slices/searchKeysSlice";
import servicesSlice from "./slices/servicesSlice";
import settingSlice, { fetchSettings } from "./slices/settingSlice";
import userAddressSlice, { setUserAddress } from "./slices/userAddressSlice";
import userSlice, { setUserData } from "./slices/userSlice";
import workerSlice from "./slices/workerSlice";
import packageSlice, { fetchPackage } from "./slices/packageSlice";
import translationSlice, { setCurrentLang } from "./slices/translationSlice";
import blogSlice from "./slices/blogSlice";
const userData = JSON.parse(localStorage.getItem("user_data"));
const userAddress = JSON.parse(localStorage.getItem("user_address"));
const cartData = JSON.parse(localStorage.getItem("cart-data")) || [];

const rootReducer = combineReducers({
  activeTabReducer: ActiveTab,
  userReducer: userSlice,
  productReducer: productSlice,
  packageReducer: packageSlice,
  workerReducer: workerSlice,
  settingReducer: settingSlice,
  cartReducer: cartSlice,
  userAddressReducer: userAddressSlice,
  addressReducer: addressSlice,
  searchKeysReducer: searchKeysSlice,
  serviceReducer: servicesSlice,
  activeSubServiceIdReducer: activeSubServiceId,
  ecomproductReducer: ecomProductSlice,
  ecompackageReducer: ecomPackageSlice,
  categoryProductReducer: categoryProductSlice,
  translationReducer: translationSlice,
  blogReducer: blogSlice,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

if (userData) {
  store.dispatch(fetchUserAddress(userData._id));
}

const getTransalationLang = () => {
  let lang = localStorage.getItem("currentLang");
  store.dispatch(setCurrentLang(lang ? lang : "ro"));
};

getTransalationLang();

store.dispatch(setUserData(userData));
store.dispatch(setUserAddress(userAddress));
store.dispatch(setCartData(cartData));
store.dispatch(fetchSettings());
store.dispatch(fetchProduct(1));
store.dispatch(fetchPackage(1));

// Not used any where till now
// store.dispatch(fetchServices(1));

export default store;
